import { isAfter } from 'date-fns';
import { serviceModel } from '~/models';
import { formatLongMonthDateWithLocalTimezone } from '~/utils';
export const futureBillingCalloutTextsPath = 'billing.callouts';
export const getFutureBillingText = (service, now, calloutsTexts)=>{
    const startBillingAt = serviceModel.startBillingAt(service);
    if (!startBillingAt) return null;
    if (!isAfter(startBillingAt, now)) return null;
    return calloutsTexts.futureBillingCallout({
        date: formatLongMonthDateWithLocalTimezone(startBillingAt)
    });
};
